module.exports = __webpack_public_path__ + "img/question12c1.880c14e7.png";